exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n}\n\n#content {\n  height: 100%;\n  width: 100%;\n  background-color: grey;\n}\n\n.right_menu {\n  background: #134E5E;\n  /* fallback for old browsers */\n  /* Chrome 10-25, Safari 5.1-6 */\n  background: linear-gradient(to right, #71B280, #134E5E);\n  /*W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/gisweb/gisweb.component.css
// module id = ../../../../../src/app/components/gisweb/gisweb.component.css
// module chunks = main